// extracted by mini-css-extract-plugin
export default {"root":"VtYP1","indicators":"_36zIL"};